import React from 'react';
import { useWallet } from '../../context/WalletContext';
import { shortenAddress } from '../../utils/wallet';
import MiniLoader from './MiniLoader';

const ConnectButton = () => {
  const { account, connect, disconnect, connecting } = useWallet();

  if (account) {
    return (
      <button className="btn btn-secondary btn-sm" onClick={disconnect} title="Click to disconnect">
        <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: 'var(--success)' }} />
        {shortenAddress(account)}
      </button>
    );
  }

  return (
    <button className="btn btn-primary btn-sm" onClick={connect} disabled={connecting}>
      {connecting ? <><MiniLoader /> Connecting</> : 'Connect Wallet'}
    </button>
  );
};

export default ConnectButton;
